/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tv } from 'tailwind-variants';
// Local
import { withStandardComponentWrapper } from 'helpers/HOC';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import ImageWrapper from 'helpers/SitecoreWrappers/ImageWrapper/ImageWrapper';
import { BrandAndThemeProvider } from 'lib/context/BrandAndThemeContext';
import RichTextWrapper from 'helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import { getTestProps } from 'lib/testing/utils';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const Quote = (props)=>{
    const isEditing = useIsEditing();
    const { title, name, description, image } = props?.fields || {};
    const theme = props?.params?.selectTheme;
    const { base, quoteWrapper, quoteTitle, quoteTypographyWrapper, quoteContentWrapper, imageStyle, nameStyle, descriptionStyle } = TAILWIND_VARIANTS({});
    return /*#__PURE__*/ _jsx("section", {
        className: base(),
        "data-component": "authorable/shared/content/Quote",
        ...editingHydrationProps(isEditing),
        ...getTestProps(`component-quote-${props?.rendering?.uid}`),
        children: /*#__PURE__*/ _jsx(BrandAndThemeProvider, {
            theme: theme,
            children: /*#__PURE__*/ _jsx("div", {
                className: quoteWrapper(),
                children: /*#__PURE__*/ _jsxs("div", {
                    className: quoteTypographyWrapper(),
                    children: [
                        /*#__PURE__*/ _jsx(PlainTextWrapper, {
                            className: quoteTitle(),
                            field: title,
                            tag: "h2",
                            ...getTestProps(`quote`)
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: quoteContentWrapper(),
                            children: [
                                image && /*#__PURE__*/ _jsx(ImageWrapper, {
                                    className: imageStyle(),
                                    field: image,
                                    ...getTestProps(`image`)
                                }),
                                /*#__PURE__*/ _jsx(PlainTextWrapper, {
                                    className: nameStyle(),
                                    field: name,
                                    tag: "h3",
                                    ...getTestProps(`name`)
                                }),
                                /*#__PURE__*/ _jsx(RichTextWrapper, {
                                    className: descriptionStyle(),
                                    field: description,
                                    ...getTestProps(`description`)
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
export const Default = withStandardComponentWrapper(Quote);
const TAILWIND_VARIANTS = tv({
    slots: {
        base: [
            'relative',
            'w-full',
            'max-w-columns-full-maxWidth'
        ],
        quoteWrapper: [
            'py-general-spacing-margin-y',
            'px-general-spacing-margin-x',
            'bg-component-quote-bg',
            'w-full',
            'rounded-general-border-radius-container',
            'overflow-hidden'
        ],
        quoteTypographyWrapper: [
            'flex',
            'flex-col',
            'items-center',
            'gap-general-spacing-copy-margin-bottom',
            'text-center',
            'text-component-quote-quote',
            'max-w-typography-copy-maxWidth'
        ],
        quoteTitle: [
            'text-component-quote-quote',
            'font-typography-font-family-header',
            'text-typography-font-size-large',
            'font-bold',
            'leading-[48px]'
        ],
        quoteContentWrapper: [
            'text-center',
            'flex',
            'flex-col',
            'gap-spacing-spacing-12'
        ],
        imageStyle: [
            'w-[64px]',
            'h-[64px]',
            'mx-auto',
            'rounded-[200px]'
        ],
        nameStyle: [
            'text-component-quote-name',
            'font-typography-font-family-body',
            'text-typography-font-size-body-large',
            'font-bold'
        ],
        descriptionStyle: [
            'text-component-quote-details',
            'font-typography-font-family-body',
            'text-typography-font-size-body-medium'
        ]
    }
});
